<template>
  <div class="bank-info">
    <p class="text">
      {{ $t('business.bankInfo.withdrawalAmount') }}<span class="value">${{ state.withdrawalAmount }}</span>
    </p>
    <p class="text">
      {{ $t('business.bankInfo.bankCharges') }}<span class="value">{{ charge }}</span>
    </p>
    <p class="text" v-if="state.withdrawalStatus">
      {{ $t('withdraw.reviewStatus') }}<span class="value">{{ state.withdrawalStatus }}</span>
    </p>
    <p class="text">{{ $t('business.bankInfo.accountInfo') }}</p>
    <div class="information">
      <x-table>
        <tr class="row row-1">
          <td class="col">{{ $t('bankInfo.bankCountry') }}</td>
          <td class="col col-value">{{ state.country }}</td>
        </tr>
        <tr class="row">
          <td class="col">Bank account currency</td>
          <td class="col col-value">{{ currency }}</td>
        </tr>
        <tr class="row" v-if="state.country != 'CA'">
          <td class="col">{{ codeLabel }}</td>
          <td class="col col-value">{{ bankInfo.bankCode }}</td>
        </tr>
        <tr class="row" >
          <td class="col">Bank name</td>
          <td class="col col-value">{{ bankInfo.bankName }}</td>
        </tr>
        <tr class="row" v-if="state.country == 'CA'">
          <td class="col">Financial institution number</td>
          <td class="col col-value">{{ bankInfo.bank_identifier }}</td>
        </tr>
        <tr class="row" v-if="state.country == 'CA'">
          <td class="col">Transit number</td>
          <td class="col col-value">{{ bankInfo.bank_sub_identifier }}</td>
        </tr>
        <tr class="row">
          <td class="col">Account number</td>
          <td class="col col-value">{{ bankInfo.cardNumber }}</td>
        </tr>
        <tr class="row">
          <td class="col">First name</td>
          <td class="col col-value">{{ bankInfo.firstName }}</td>
        </tr>
        <tr class="row">
          <td class="col">Last name</td>
          <td class="col col-value">{{ bankInfo.lastName }}</td>
        </tr>
        <tr class="row" v-if="isShowInput()">
          <td class="col">Your State</td>
          <td class="col col-value">{{ bankInfo.yourState }}</td>
        </tr>
        <tr class="row" v-if="isShowInput()">
          <td class="col">Your City</td>
          <td class="col col-value">{{ bankInfo.yourCity }}</td>
        </tr>
        <tr class="row" v-if="isShowInput()">
          <td class="col">Your Street</td>
          <td class="col col-value">{{ bankInfo.yourStreet }}</td>
        </tr>
        <tr class="row" v-if="isShowInput()">
          <td class="col">Post Code</td>
          <td class="col col-value">{{ bankInfo.postCode }}</td>
        </tr>
        <tr class="row">
          <td class="col">Signature</td>
          <td class="col col-value"><img :src="bankInfo.signature" alt="" srcset="" /></td>
        </tr>
      </x-table>
    </div>
  </div>
</template>
<script>
import { XTable } from 'vux'
import state from '@/state.js'
import { CURRENCY_MAP, CODE_LABEL_MAP } from '@/utils/constants'
export default {

  components: {
    XTable
  },
  data() {
    return {
      state
    }
  },
  computed: {
    bankInfo() {
      return this.state.bankInfo
    },
    currency() {
      return CURRENCY_MAP[this.state.country]
    },
    charge() {
      let countryLists = ["CA", "AT", "FR", "DE"]; //加拿大、奥地利、法国、德国
      if (countryLists.includes(this.state.country)) {
        return "$3";
      } else if (this.state.country == "US") {
        return "$2";
      } else if (this.state.country == "MX") { //墨西哥
        return "$2";
      } else if (this.state.country == "PE") { //秘鲁
        return "$4.5";
      }else if (this.state.country == "CO") { //哥伦比亚
        return "$3.5";
      }else{
        return "$3";
      }
    },
    codeLabel() {
      return CODE_LABEL_MAP[this.state.country]
    }
  },
  methods: {
    isShowInput() {
      // 是否展示输入框

      if (this.state.country == 'US' || this.state.country == 'CA') {
        // 这两个国家
        if (this.state.userWithdrawalAddress == 1) {
          // 且值为1
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss">
.bank-info {
  .text {
    margin-bottom: 13px;

    color: #3c3c43;

    .value {
      padding-left: 12px;

      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      vertical-align: middle;

      color: #BA30F5;
    }
  }

  .information {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    background: #fff;
  }

  .vux-table:after {
    display: none;
  }

  .row:last-child td:before {
    display: none;
  }

  .col {
    padding: 17px 16px;
    width: 50%;

    line-height: 19px;

    color: #3c3c43;
  }

  .col-value {
    font-weight: 600;
    text-align: left;
  }
}
</style>
